import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { LaunchNavigator } from '@ionic-native/launch-navigator/ngx';
import { NativeGeocoder } from '@ionic-native/native-geocoder/ngx';
import { TranslateService } from '@ngx-translate/core';
import { RatingModule, StarRatingComponent } from 'ng-starrating';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { LocationService } from '../location.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
  providers: [RatingModule]
})
export class FeedbackComponent  {
  data:any = []; i=0; show:any; score = 0; loader:boolean;
  id;
  comments;
  msg;
  purrchaseItems=[];
  reqId;
  orderid;
  dateFormat;
  assessId;
  orderId;
  assessname;
  constructor( private service: ApiService,
    public handler: HandlerService,
    public router: Router,
    public translate: TranslateService,
    private launchNavigator: LaunchNavigator,
      private geoCoder:NativeGeocoder,
    public auth: AuthService,  public location: LocationService,private rating:RatingModule) { }

    Orderget(){
      this.dateFormat = this.auth.getDateformat();
      this.orderId='2974'
      this.loader = true;    
    
      this.orderid=localStorage.getItem('orderId')
      this.service.getOrderById(this.orderid).subscribe((res:any) => {
        if (res) {
         this.purrchaseItems = res;
         this.orderid = res.id;
        //  this.pay = res.paymtStatus;
                 this.loader = false;
     
        }
     
        })
    }
    
    ionViewWillEnter(){
           this.loader = true; 
           this.orderId='2974'
           this. Orderget();
      this.id = window.location.href.split('/').pop();
      this.orderid=localStorage.getItem('orderId')
      if(this.data){
        this.service.getAssessmentsByServiceId(this.id).subscribe((res:any)=>{
          if(res !=null){
          this.assessId=res[this.i].id;
          this.assessname=res[this.i].name;
          if(res[this.i].questions){
            this.data = res[this.i].questions;
            this.show = this.data[this.i];
          }
          else{
            this.msg="No Assessment questions for You"
          }
          }
          else{
          this.msg= "No Assessment For You";
          }
          this.loader = false;
        })
      }
    }
  
    next(){
      this.loader = true;
      if(this.comments){
        this.comments = this.comments.toUpperCase();
      }
      var post={comments:this.comments}
      this.service.postScoreAssessment(this.assessId,this.show.id,1,this.score,post).subscribe(res=>{
        this.comments="";
        this.score = 0;
        let len = this.data.length;
        if(this.i < len - 1){
          this.i++;
          this.show = this.data[this.i];
        }
        else{
          this.score = 0;
          this.handler.res('Your assessments has been submitted successfully');
          sessionStorage.clear();
          this.router.navigate(['/bookservice']);
        }
        this.loader = false;
      })
    }
  
    onRate(event){
      this.score = event.newValue
    }
    ionViewWillLeave(){
      this.assessname=undefined;
    }
  // ionViewWillLeave(){
  //   this.orderid=undefined;
  // }
  back(){
    this.router.navigate(['invoice/', this.orderid])
  }
}
